<template>
    <div class="container-fluid py-3">
        <div class="card shadow-sm">
            <div class="card-header pb-0 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div class="d-flex align-items-center gap-2">
                    <span class="cal-header-icon cal-header-icon--blue">
                        <i class="bi bi-shield-shaded"></i>
                    </span>
                    <div>
                        <h6 class="mb-0 fw-bold font-weight-bolder">Sığorta şəhadətnamələri</h6>
                        <small class="text-muted" style="font-size: 0.78rem;">Qüvvədə olan və arxiv sığorta şəhadətnamələrinin reyestri</small>
                    </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <button type="button" class="btn action-btn action-btn--muted" @click="GetQuotas()">
                        <i class="bi bi-arrow-clockwise me-1"></i>
                        <span>Yeniləmək</span>
                    </button>
                    <button
                        type="button"
                        @click="showFilter = !showFilter"
                        class="btn action-btn"
                        :class="showFilter ? 'action-btn--info' : 'action-btn--muted'"
                        title="Filter"
                    >
                        <i class="bi bi-funnel-fill"></i>
                    </button>
                </div>
            </div>

            <div class="card-body">
                <transition name="slide">
                    <div class="filter-panel-card mb-4 p-3 rounded" v-show="showFilter">
                        <div class="row align-items-end g-3">
                            <div class="col-sm-6 col-md-3 col-lg-2">
                                <label class="form-label mb-1">Status</label>
                                <el-select v-model="status" placeholder="Seçin" class="w-100">
                                    <el-option label="Bütün" :value="-1" />
                                    <el-option label="Qüvvədə olanlar" :value="0" />
                                    <el-option label="Qüvvədən düşmüşlər" :value="1" />
                                    <el-option label="Gözlənilənlər" :value="2" />
                                </el-select>
                            </div>
                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <label class="form-label mb-1">Tarix aralığı</label>
                                <div class="d-flex align-items-center gap-2">
                                    <el-date-picker format="DD.MM.YYYY" :disabled-date="DisableStartDate"
                                        v-model="date1" type="date" class="w-50" placeholder="Başlanğıc" />
                                    <el-date-picker format="DD.MM.YYYY" :disabled-date="DisableEndDate"
                                        v-model="date2" type="date" class="w-50" placeholder="Son" />
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-6">
                                <div class="app-search-form-group">
                                    <el-input
                                        v-model="srcText"
                                        placeholder="Tam adı / FIN / Müqavilə nömrəsi"
                                        clearable
                                        class="app-search-input"
                                        @keydown.enter="GetQuotas()"
                                    />
                                    <button type="button" @click="GetQuotas()" class="btn app-search-btn">
                                        <i class="bi bi-search"></i>
                                        <span>Axtar</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <div v-loading="loading">
                    <Table @get-data="GetQuotas" :data="data" :showFilter="showFilter"></Table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Table from "./Components/Table.vue";
import dayjs from 'dayjs';

export default {
    components: {
        Table
    },
    data() {
        return {
            loading: null,
            srcText: null,
            data: [
                {
                    medicalPolicy: {
                        issued: true,
                        signStatus: 'İmzalanıb',
                        policyId: 1001,
                        policyFullNumber: "SS-2025-000123",
                        policyStatusName: "Aktiv",
                        policyDateStr: "16.08.2025",
                        insuredPerson: { name: "Elvin Əliyev" },
                        insured: { name: "Əli Məmmədov" },
                        startDateStr: "01.01.2025",
                        endDateStr: "31.12.2025",
                        cancelDateStr: "",
                        payType: "Aylıq",
                        currency: "AZN",
                        cancelTypeName: ""
                    }
                },
                {
                    medicalPolicy: {
                        issued: false,
                        policyId: 1002,
                        signStatus: 'Kuratorun imzası gözlənilir',
                        policyFullNumber: "SS-2025-000124",
                        policyStatusName: "Dayandırılıb",
                        policyDateStr: "10.07.2025",
                        insured: { name: "Leyla Quliyeva" },
                        startDateStr: "01.02.2025",
                        insuredPerson: { name: "Leyla Məmmədova" },
                        endDateStr: "01.08.2025",
                        payType: "Aylıq",
                        currency: "AZN",
                        cancelDateStr: "05.07.2025",
                        cancelTypeName: "Müştəri tələbi ilə"
                    }
                },
                {
                    medicalPolicy: {
                        issued: true,
                        policyId: 1003,
                        signStatus: 'İmzalanıb',
                        policyFullNumber: "SS-2025-000125",
                        policyStatusName: "Aktiv",
                        policyDateStr: "05.06.2025",
                        insured: { name: "Rauf Həsənov" },
                        startDateStr: "15.06.2025",
                        endDateStr: "15.06.2026",
                        payType: "Birdəfəlik",
                        insuredPerson: { name: "Elvin Bayramov" },
                        currency: "USD",
                        cancelDateStr: "",
                        cancelTypeName: ""
                    }
                }
            ],
            dialogVis: false,
            status: 0,
            date1: new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().split("T")[0],
            date2: new Date(),
            showFilter: true,
            companyName: null
        }
    },
    methods: {
        DisableStartDate(date) {
            return this.date2 && dayjs(date).isAfter(dayjs(this.date2), 'day')
        },
        DisableEndDate(date) {
            return this.date1 && dayjs(date).isBefore(dayjs(this.date1), 'day')
        },
        NewPolicy() {
            window.open(window.location.origin + '/documents/policy', "_blank");
        },
        GetQuotas() {

            //None 
        }
    },
    mounted() {
        this.GetQuotas()
    }
}
</script>